import * as React from "react";
import { memo } from "react";
const SvgCross = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.4 27L13 25.6L18.6 20L13 14.4L14.4 13L20 18.6L25.6 13L27 14.4L21.4 20L27 25.6L25.6 27L20 21.4L14.4 27Z", fill: "currentColor" }));
const Memo = memo(SvgCross);
export default Memo;
